import React, { useState, useEffect, useCallback, use, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DevisList.css';
//import InvoiceForm from '../InvoiceFormx';
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaCashRegister, FaCheckCircle, FaEdit, FaEllipsisH, FaFilePdf, FaFilter, FaInfo, FaPlus, FaSearch, FaTrash } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import DevisForm from './DevisForm';
import { devisActions } from '../../sagas/devisSlice';
import { useNavigate } from 'react-router-dom';
import { convertNumberToWords, formatPrice } from '../../helpers/utility';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import autoTable from 'jspdf-autotable';
import { productActions } from '../../sagas/productSlice';
import { debounce } from 'lodash';
import { clientActions } from '../../sagas/clientSlice';
import Select from "react-select";
import { generateDoc } from '../../helpers/generateDoc';
import DocumentPagination from '../Common/DocumentPagination';
import '../Common/DocumentList.css';

const DevisList = () => {
    const dispatch = useDispatch();
    const { list, loading, totalPages, pageNumber, pageSize, totalElements } = useSelector((state) => state.devis);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [selectedDevis, setSelectedDevis] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unites
    const clients = useSelector(state => state.clients.clients);
    const [selectedClient, setSelectedClient] = useState(null);

    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const getMonthRange = (monthValue) => {
        if (!monthValue) return { dateFrom: formatDate(todayDate), dateTo: formatDate(tomorrowDate) };
        const [year, month] = monthValue.split('-').map(Number);
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        return { dateFrom: formatDate(firstDay), dateTo: formatDate(lastDay) };
    };
    const searchInputRef = useRef(null);

    const [filters, setFilters] = useState({
        clientId: null,
        chantierId: null,
        dateFrom: formatDate(todayDate),
        dateTo: formatDate(tomorrowDate),
        query: '',
        status: '',
        month: '',
        page: 0,
        size: 10
    });


    useEffect(() => {
        dispatch(clientActions.search({ query: "" }));
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(devisActions.list(payload));
    }, [filters.clientId, filters.chantierId, filters.dateFrom, filters.dateTo, filters.commercialId, filters.status, filters.page, filters.size]);


    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [list]);

    const handleGeneratePdf = async (devis) => {
        Swal.fire({
            title: t('commande.pdfPriceOption', 'Prix à afficher'),
            text: t('commande.pdfPriceOptionText', 'Choisissez le type de prix à afficher dans le PDF'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('commande.prixTTC', 'Prix TTC'),
            cancelButtonText: t('commande.prixHT', 'Prix HT'),
            showCloseButton: true,
            closeButtonHtml: '&times;',
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.close) {
                return;
            }

            const showTTCPrices = result.isConfirmed;
            generateDoc("devis", {
                matjarDoc: {
                    ...devis, lignes: devis.lignes.map(l => ({
                        ...l,
                        unite: unites.find(u => u.code === l.unite)?.libelle
                    }))
                },
                sellerModel: company,
                priceMode: showTTCPrices ? "TTC" : "HT",
                open: true,
            });
        });
    };



    const handleDeleteDevis = (devisId) => {
        setPopoverOpen(!popoverOpen)
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce devis?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.delete({
                    id: devisId, onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Supprimé!',
                            text: 'Le Devis a été supprimée.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    }
                }));
            }
        });
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        if (selectedDevis) {
            setSelectedDevis(null);
        }
        let payload = {
            ...filters
        };
        dispatch(devisActions.list(payload));
    };


    const handleAcceptDevis = (devis) => {
        Swal.fire({
            title: 'Confirmation',
            text: "Le devis sera converti en bon de commande, voulez-vous confirmer?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(devisActions.accepterDevis({
                    id: devis.id,
                    onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Accepté!',
                            text: 'Le devis a été accepté avec succès.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        let payload = {
                            ...filters
                        };
                        dispatch(devisActions.list(payload));
                    }
                }));
            }
        });
    };

    const handleUpdateDevis = (devis) => {
        setSelectedDevis(devis);
        setShowModal(true);
        setPopoverOpen(!popoverOpen)
    };

    const debouncedSearch = () => {
        dispatch(devisActions.list({
            ...filters,
        }));
    }

    const clearFilters = () => {
        setFilters({
            query: '',
            clientId: null,
            chantierId: null,
            dateFrom: formatDate(todayDate),
            dateTo: formatDate(tomorrowDate),
            status: '',
            month: '',
            page: 0,
            size: 10
        });
    };

    const clientOptions = clients?.map(client => ({
        value: client.id,
        label: client.typeClient === 'PARTICULIER'
            ? `${client.nom} ${client.prenom || ''} `
            : client.entreprise,
        chantiers: client.chantiers || []
    })) ?? [];

    const clientOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...clientOptions
    ];

    // Create chantier options from selected client's chantiers
    const chantierOptions = selectedClient?.chantiers?.map(chantier => ({
        value: chantier.id,
        label: `${chantier.code} - ${chantier.nom}`,
        ...chantier
    })) || [];

    const chantierOptionsWithAll = [
        { value: null, label: t('common.all', 'Tous') },
        ...chantierOptions
    ];

    return (
        <Container fluid>
            <Row className="mb-4">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaCashRegister className="text-primary me-2" />
                                {t('devis.list')}
                            </h4>
                            <div className="d-flex align-items-center">
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="mr-2" /> {t('devis.newDevis')}
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-4">
	                                <Row className="mb-3 g-2 align-items-end doc-filter-row">
                                    <Col lg={3} md={4} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('devis.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value,
                                                            page: 0
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label htmlFor="clientId">{t('bonLivraison.client')}:</Label>
                                            <Select
                                                id="clientId"
                                                options={clientOptionsWithAll}
                                                value={clientOptionsWithAll.find(option => option.value === filters.clientId)}
                                                onChange={(selectedOption) => {
                                                    setFilters(f => ({ ...f, clientId: selectedOption ? selectedOption.value : null, page: 0 }));
                                                    setSelectedClient(selectedOption);
                                                }}
                                                placeholder={t('bonLivraison.selectClient')}
                                                isSearchable
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="status" className="mb-1">{t('devis.status')}</Label>
                                            <Input
                                                type="select"
                                                id="status"
                                                value={filters.status}
                                                onChange={e => setFilters(f => ({ ...f, status: e.target.value, page: 0 }))}
                                            >
                                                <option value="">{t('common.all', 'Tous')}</option>
                                                <option value="EN_ATTENTE">{t('devis.statusDraft')}</option>
                                                <option value="VALIDE">{t('devis.statusValidated')}</option>
                                                <option value="ANNULE">{t('devis.statusCancelled')}</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="month" className="mb-1">{t('common.month', 'Mois')}</Label>
                                            <Input
                                                type="month"
                                                id="month"
                                                value={filters.month}
                                                onChange={e => {
                                                    const range = getMonthRange(e.target.value);
                                                    setFilters(f => ({ ...f, month: e.target.value, ...range, page: 0 }));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, dateFrom: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, dateTo: e.target.value, month: '', page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="mb-3"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
	                            <DocumentPagination
	                                pageNumber={pageNumber}
	                                totalPages={totalPages}
	                                totalElements={totalElements}
	                                pageSize={pageSize}
	                                onPageChange={(page) => setFilters(f => ({ ...f, page }))}
	                            />
	                            <div className="doc-list">
                                {list.map((devis) => (
                                    <div className="doc-row" key={devis.id}>
                                        <div className="doc-row-main">
                                            <strong>{devis.numero}</strong>
                                            <span>{t('devis.dateCreation')}: {devis.dateCreation || '-'}</span>
                                            <span>{t('devis.dateOperation')}: {devis.dateOperation || '-'}</span>
                                        </div>
                                        <div className="doc-client">
                                            <strong>{devis.clientNom || '-'}</strong>
                                            <span>{t('common.user')}: {devis.createdBy || '-'}</span>
                                        </div>
                                        <div className="doc-amounts">
                                            <div className="doc-amount">
                                                <span>{t('devis.montantTTC')}</span>
                                                <strong>{formatPrice(devis.montantTotalTTC)}</strong>
                                            </div>
                                        </div>
                                        <div className="doc-statuses">
                                            {devis.statut === 'EN_ATTENTE' && (
                                                <span className="badge bg-secondary">{t('devis.statusDraft')}</span>
                                            )}
                                            {devis.statut === 'VALIDE' && (
                                                <span className="badge bg-success">{t('devis.statusValidated')}</span>
                                            )}
                                            {devis.statut === 'ANNULE' && (
                                                <span className="badge bg-danger">{t('devis.statusCancelled')}</span>
                                            )}
                                        </div>
                                        <div className="doc-actions">
                                            <Button color="secondary" title={t('devis.downloadPdf')} onClick={() => handleGeneratePdf(devis)} className="doc-icon-btn" size="sm">
                                                <FaFilePdf />
                                            </Button>
                                            {devis.statut === 'EN_ATTENTE' && (
                                                <Button color="success" title={t('devis.devisValide')} onClick={() => handleAcceptDevis(devis)} className="doc-icon-btn" size="sm">
                                                    <FaCheckCircle />
                                                </Button>
                                            )}
                                            <Button color="warning" title={t('devis.edit')} onClick={() => handleUpdateDevis(devis)} size="sm" className="doc-icon-btn">
                                                <FaEdit />
                                            </Button>
                                            {devis.statut === 'EN_ATTENTE' && (
                                                <Button color="danger" title={t('devis.cancel')} onClick={() => handleDeleteDevis(devis.id)} className="doc-icon-btn" size="sm">
                                                    <FaTrash />
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                {list.length === 0 && <div className="doc-empty">{t('devis.noDevis')}</div>}
                            </div>
	                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showModal} toggle={handleCloseModal} size="xl"
                className="modal-fullscreen-lg-down"
                style={{ maxWidth: '95%', width: '95%', margin: '10px auto' }}
            >
                <ModalHeader toggle={handleCloseModal}

                >{selectedDevis ? `${t('devis.editDevis')} N° ${selectedDevis.numero}` : t('devis.newDevis')}</ModalHeader>
                <ModalBody>
                    <DevisForm preloadedCompany={company} devis={selectedDevis} onClose={handleCloseModal} />
                </ModalBody>
            </Modal>
        </Container>
    );
};

export default DevisList;
